import { render } from "./Empty.vue?vue&type=template&id=76757be5"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"

import "./Empty.vue?vue&type=style&index=0&id=76757be5&lang=less"
script.render = render

export default script